import { alpha } from '@mui/material';
import { Palette, PaletteColor, Theme } from '@mui/material/styles';
import { StyleRules } from '@mui/styles';

export const useBackButtonStyles = (
  typography: Theme['typography'],
  palette: Theme['palette'],
  spacing: Theme['spacing']
): StyleRules<{}, 'backButton'> => {
  return {
    backButton: {
      ...typography.subtitle2,
      textDecoration: 'none !important',
      display: 'inline-flex !important',
      width: 'max-content !important',
      alignItems: 'center !important',
      '&:not(:hover)': {
        color: palette.text.secondary,
        background: palette.mode === 'dark' ? 'transparent' : 'inherit',
      },
      '&:hover': {
        background: palette.mode === 'dark' ? 'transparent !important' : 'inherit',
      },
      '& svg': {
        marginRight: spacing(1.5),
      },
      '&:visited': {
        color: 'inherit',
      },
      padding: '0 2px',
    },
  };
};

const makeVariants = (color: PaletteColor) => {
  return {
    text: {
      color: color.main,
    },
    contained: {
      backgroundColor: color.main,
      color: color.contrastText,
      '&:hover': { backgroundColor: color.dark },
    },
    outlined: {
      color: color.main,
      borderColor: alpha(color.main, 0.5),
    },
  };
};

export const useInfoButtonStyles = (palette: Palette) => {
  return makeVariants(palette.info);
};

export const useWarningButtonStyles = (palette: Palette) => {
  return makeVariants(palette.warning);
};

export const useErrorButtonStyles = (palette: Palette) => {
  return makeVariants(palette.error);
};
export const useSuccessButtonStyles = (palette: Palette) => {
  return makeVariants(palette.success);
};
